/**
 * モバイルメニュー - スライド式階層ナビゲーション
 * サイドバーのカテゴリナビをヘッダードロワーに統合
 */

document.addEventListener('DOMContentLoaded', function() {
  const mobileSidebarCategories = document.getElementById('mobile-sidebar-categories');
  const mobileSidebarBanners = document.getElementById('mobile-sidebar-banners');
  const menuDrawer = document.getElementById('menu-drawer');
  
  let categoriesLoaded = false;
  let bannersLoaded = false;
  let panelStack = []; // パネルの履歴を管理

  // メニュードロワーが開かれたときに実行
  if (menuDrawer) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          const detailsElement = mutation.target;
          
          if (detailsElement.hasAttribute('open')) {
            // メニューが開かれた
            if (!categoriesLoaded && mobileSidebarCategories) {
              initSlidingCategoryNav();
              categoriesLoaded = true;
            }
            
            if (!bannersLoaded && mobileSidebarBanners) {
              copySidebarBannersToMobile();
              bannersLoaded = true;
            }
          }
        }
      });
    });

    // Details要素を監視
    const detailsElement = document.getElementById('Details-menu-drawer-container');
    if (detailsElement) {
      observer.observe(detailsElement, {
        attributes: true
      });
    }
  }

  // スライド式カテゴリナビゲーションの初期化
  function initSlidingCategoryNav() {
    if (!mobileSidebarCategories) {
      return;
    }

    // UIコンテナを構築
    const container = document.createElement('div');
    container.className = 'mobile-sidebar-slide-container';
    
    // 第一階層: カテゴリトリガー（既存メニューと統一）
    const trigger = document.createElement('button');
    trigger.className = 'mobile-sidebar-category-trigger';
    trigger.type = 'button';
    trigger.innerHTML = `
      <span>📂 商品カテゴリから探す</span>
      <span class="trigger-icon">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
          <path fill="currentColor" fill-rule="evenodd" d="M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546" clip-rule="evenodd"></path>
        </svg>
      </span>
    `;
    
    trigger.addEventListener('click', function() {
      loadCategoryData();
    });
    
    container.appendChild(trigger);
    mobileSidebarCategories.appendChild(container);
  }

  // カテゴリデータを読み込む（サイドバーから常に構築）
  function loadCategoryData() {
    const sidebar = document.querySelector('.sidebar');
    
    if (sidebar) {
      const categoryGroups = sidebar.querySelectorAll('.shopify-section-group-sidebar-categories-group-1, .shopify-section-group-sidebar-categories-group-2');
      
      if (categoryGroups.length > 0) {
        const categoryData = buildCategoryData(categoryGroups);
        openPanel('main', categoryData);
        return;
      }
    }
    
    console.error('[Mobile Menu] No category data available');
  }

  // カテゴリデータを構築
  function buildCategoryData(categoryGroups) {
    const data = [];
    
    categoryGroups.forEach((group, groupIndex) => {
      const h3Items = group.querySelectorAll('h3');
      
      h3Items.forEach((h3) => {
        const link = h3.querySelector('a');
        const span = h3.querySelector('span.nolink');
        
        if (link || span) {
          const category = {
            title: (link || span).textContent.trim(),
            href: link ? link.href : null,
            subcategories: []
          };
          
          
          // サブカテゴリを探す
          let nextElement = h3.parentElement;
          if (nextElement) {
            let sibling = nextElement.nextElementSibling;
            while (sibling) {
              const h4 = sibling.querySelector('h4');
              if (h4) {
                const subLink = h4.querySelector('a');
                if (subLink) {
                  const subcategory = {
                    title: subLink.textContent.trim(),
                    href: subLink.href,
                    products: []
                  };
                  
                  
                  // ツールチップ内の商品リストを取得
                  const tooltip = sibling.querySelector('.tooltip');
                  if (tooltip) {
                    const productLinks = tooltip.querySelectorAll('ul li a');
                    productLinks.forEach((productLink) => {
                      subcategory.products.push({
                        title: productLink.textContent.trim(),
                        href: productLink.href
                      });
                    });
                  } else {
                  }
                  
                  category.subcategories.push(subcategory);
                }
              } else if (sibling.querySelector('h3')) {
                break;
              }
              sibling = sibling.nextElementSibling;
            }
          }
          
          data.push(category);
        }
      });
    });
    
    return data;
  }

  // パネルを開く
  function openPanel(panelType, data) {
    const container = document.querySelector('.mobile-sidebar-slide-container');
    const menuDrawerNav = document.querySelector('.menu-drawer__navigation');
    const menuDrawerUtility = document.querySelector('.menu-drawer__utility-links');
    
    // メインメニューを隠す
    if (menuDrawerNav) {
      menuDrawerNav.style.display = 'none';
    }
    if (menuDrawerUtility) {
      menuDrawerUtility.style.display = 'none';
    }
    
    // バナーも一時的に隠す
    if (mobileSidebarBanners) {
      mobileSidebarBanners.style.display = 'none';
    }
    
    // 既存のパネルを非アクティブに
    const existingPanels = container.querySelectorAll('.mobile-sidebar-slide-panel');
    existingPanels.forEach(panel => {
      if (panel.classList.contains('active')) {
        panel.classList.remove('active');
        panel.classList.add('exiting');
        setTimeout(() => {
          panel.classList.remove('exiting');
        }, 300);
      }
    });
    
    // 新しいパネルを作成
    const panel = createPanel(panelType, data);
    container.appendChild(panel);
    
    // アニメーション用に少し遅延
    setTimeout(() => {
      panel.classList.add('active');
    }, 10);
    
    // スタックに追加
    panelStack.push({ panelType, data, element: panel });
  }

  // パネルを作成
  function createPanel(panelType, data) {
    const panel = document.createElement('div');
    panel.className = 'mobile-sidebar-slide-panel';
    
    // ヘッダー
    const header = document.createElement('div');
    header.className = 'mobile-sidebar-panel-header';
    header.innerHTML = `
      <button type="button" class="mobile-sidebar-back-btn">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
          <path fill="currentColor" fill-rule="evenodd" d="M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546" clip-rule="evenodd"></path>
        </svg>
      </button>
      <span class="mobile-sidebar-panel-title">${panelType === 'main' ? '商品カテゴリ' : data.title || ''}</span>
    `;
    
    header.querySelector('.mobile-sidebar-back-btn').addEventListener('click', function() {
      closePanel();
    });
    
    panel.appendChild(header);
    
    // リスト
    const list = document.createElement('ul');
    list.className = 'mobile-sidebar-panel-list';
    
    if (panelType === 'main') {
      // メインカテゴリ一覧
      data.forEach((category) => {
        const item = document.createElement('li');
        item.className = 'mobile-sidebar-panel-item';
        
        if (category.subcategories.length > 0) {
          // サブカテゴリがある場合はボタン
          item.innerHTML = `
            <button type="button">
              <span>${category.title}</span>
              <span class="item-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                  <path fill="currentColor" fill-rule="evenodd" d="M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546" clip-rule="evenodd"></path>
                </svg>
              </span>
            </button>
          `;
          
          item.querySelector('button').addEventListener('click', function() {
            openPanel('sub', category);
          });
        } else if (category.href) {
          // サブカテゴリがない場合は直接リンク
          item.innerHTML = `
            <a href="${category.href}">
              <span>${category.title}</span>
            </a>
          `;
        }
        
        list.appendChild(item);
      });
    } else if (panelType === 'sub') {
      // サブカテゴリ一覧
      data.subcategories.forEach((subcategory) => {
        const item = document.createElement('li');
        item.className = 'mobile-sidebar-panel-item';
        
        if (subcategory.products && subcategory.products.length > 0) {
          // 商品リストがある場合はボタン
          item.innerHTML = `
            <button type="button">
              <span>${subcategory.title}</span>
              <span class="item-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                  <path fill="currentColor" fill-rule="evenodd" d="M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546" clip-rule="evenodd"></path>
                </svg>
              </span>
            </button>
          `;
          
          item.querySelector('button').addEventListener('click', function() {
            openPanel('products', subcategory);
          });
        } else {
          // 商品リストがない場合は直接リンク
          item.innerHTML = `
            <a href="${subcategory.href}">
              <span>${subcategory.title}</span>
            </a>
          `;
        }
        
        list.appendChild(item);
      });
    } else if (panelType === 'products') {
      // 商品一覧
      data.products.forEach((product) => {
        const item = document.createElement('li');
        item.className = 'mobile-sidebar-panel-item';
        item.innerHTML = `
          <a href="${product.href}">
            <span>${product.title}</span>
          </a>
        `;
        list.appendChild(item);
      });
    }
    
    panel.appendChild(list);
    
    return panel;
  }

  // パネルを閉じる
  function closePanel() {
    if (panelStack.length === 0) return;
    
    const currentPanel = panelStack.pop();
    currentPanel.element.classList.remove('active');
    
    setTimeout(() => {
      currentPanel.element.remove();
    }, 300);
    
    // 前のパネルをアクティブに
    if (panelStack.length > 0) {
      const previousPanel = panelStack[panelStack.length - 1];
      previousPanel.element.classList.add('active');
    } else {
      // 最後のパネルを閉じたらメインメニューを表示
      const menuDrawerNav = document.querySelector('.menu-drawer__navigation');
      const menuDrawerUtility = document.querySelector('.menu-drawer__utility-links');
      
      if (menuDrawerNav) {
        menuDrawerNav.style.display = '';
      }
      if (menuDrawerUtility) {
        menuDrawerUtility.style.display = '';
      }
      
      // バナーも再表示
      if (mobileSidebarBanners) {
        mobileSidebarBanners.style.display = '';
      }
    }
  }

  // サイドバーのバナーをモバイルメニューにコピー
  function copySidebarBannersToMobile() {
    if (!mobileSidebarBanners) {
      return;
    }

    const sidebar = document.querySelector('.sidebar');
    
    if (!sidebar) {
      return;
    }

    // バナーグループを取得
    const bannerGroups = sidebar.querySelectorAll('.shopify-section-group-sidebar-banner-top-group, .shopify-section-group-sidebar-banner-bottom-group');
    
    if (bannerGroups.length === 0) {
      return;
    }

    const container = document.createElement('div');
    container.className = 'mobile-sidebar-banner-container';
    
    let bannersAdded = 0;
    
    bannerGroups.forEach((group) => {
      // 直接.sidebar-bannerと.sidebar-notice-boxを探す
      const bannerDivs = group.querySelectorAll('.sidebar-banner');
      const noticeBoxes = group.querySelectorAll('.sidebar-notice-box');
      
      // バナー画像
      bannerDivs.forEach((bannerDiv) => {
        const clone = bannerDiv.cloneNode(true);
        container.appendChild(clone);
        bannersAdded++;
      });
      
      // 通知ボックス
      noticeBoxes.forEach((noticeBox) => {
        const clone = noticeBox.cloneNode(true);
        container.appendChild(clone);
        bannersAdded++;
      });
    });
    
    if (bannersAdded > 0) {
      mobileSidebarBanners.appendChild(container);
    }
  }
});
